import { take, put, select, call } from 'redux-saga/effects'
import {
  SET_CONDITION_FIELD,
  setConditionField,
} from 'actions/feature/conditions'
import { getCondition } from 'selectors/feature/conditions'

import { calculateNewStartBit } from 'components/feature/utils/bitGrid'

const fieldChangeHandlers = {
  numberOfBits: updateNumberOfBits,
}

export function* watchConditionField() {
  while (true) {
    const { uri, paramName, value } = yield take(SET_CONDITION_FIELD)

    if (fieldChangeHandlers[paramName]) {
      const setField = (param, val) => put(setConditionField(uri, param, val))

      yield call(fieldChangeHandlers[paramName], {
        uri,
        value,
        setField,
      })
    }
  }
}

function* updateNumberOfBits({ uri, value, setField }) {
  const condition = yield select(getCondition, { queryUri: uri })

  const { startBit } = condition

  const newStartBit = calculateNewStartBit(startBit, value, 'input')

  if (newStartBit !== startBit) {
    yield setField('startBit', newStartBit)
  }
}
